import {
    BlockMapBuilder, convertFromHTML, EditorState, Modifier,
} from 'draft-js';
import $ from 'jquery';
import { getApiUploadExternalImageUrl, getApiUploadBase64ImageUrl } from '../../utilities/urlHelper';

const MAX_FILE_SIZE = 50000000; // 50mb
const FILE_SIZE_MB = MAX_FILE_SIZE / 1000000;

const EVERNOTE_EXT = 'enex';

const IMAGE_TYPES = [
    'image/bmp',
    'image/x-windows-bmp',
    'image/gif',
    'image/jpeg',
    'image/pjpeg',
    'image/png',
    'image/tiff',
    'image/x-tiff',
];

const INTERNAL_FILE_URL_REGEX = /https:\/\/tettra-\w+\.s3/;

const BASE_64_REGEX = /^data:(image\/\w+);.*base64/;

const isImage = file => (IMAGE_TYPES.includes(file.type));

const isBase64Image = (url) => BASE_64_REGEX.test(url.trimStart());

const isExternalFile = (url) => !INTERNAL_FILE_URL_REGEX.test(url);

const isExternalImage = (url) => isExternalFile(url) && !isBase64Image(url);

const uploadFile = (file, postURL) => new Promise((resolve, reject) => {
    const data = new FormData();
    data.append('file', file);
    data.append('_token', window.csrfToken);
    $.ajax({
        url: postURL,
        type: 'POST',
        data,
        cache: false,
        dataType: 'json',
        processData: false,
        contentType: false,
    }).done((response) => {
        resolve(response.file);
    }).fail(error => reject(error));
});

const uploadExternalImage = (external_image_url) => $.post(getApiUploadExternalImageUrl(), { external_image_url, _token: window.csrfToken });

const uploadBase64Image = (image_data) => $.post(getApiUploadBase64ImageUrl(), { image_data, _token: window.csrfToken });

const isEvernoteFile = file => !file.type && file.name.split('.').pop().includes(EVERNOTE_EXT);

const shouldImportFile = file => isEvernoteFile(file);

const convertEvernoteToHTML = file => new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
        const enex = e.target.result;
        const rawHTML = $('<div>').append($(enex));
        resolve(rawHTML.find('en-note').clone().remove().html());
    };

    fileReader.onerror = (error) => {
        reject(error);
    };

    fileReader.readAsText(file, 'utf-8');
});

const importFileToEditorState = (file, editorState) => new Promise((resolve, reject) => {
    if (isEvernoteFile) {
        convertEvernoteToHTML(file)
            .then((rawHTML) => {
                const htmlFragment = convertFromHTML(rawHTML);
                const blockMap = BlockMapBuilder.createFromArray(htmlFragment.contentBlocks);
                const newState = Modifier.replaceWithFragment(
                    editorState.getCurrentContent(),
                    editorState.getSelection(),
                    blockMap,
                );
                resolve(EditorState.push(editorState, newState, 'insert-fragment'));
            }).catch(e => reject(e));
    } else {
        reject(new Error('File not imported'));
    }
});

const isSupportedSize = file => file.size < MAX_FILE_SIZE;

export {
    convertEvernoteToHTML,
    importFileToEditorState,
    isBase64Image,
    isEvernoteFile,
    isExternalFile,
    isExternalImage,
    isImage,
    isSupportedSize,
    shouldImportFile,
    uploadBase64Image,
    uploadFile,
    uploadExternalImage,
    FILE_SIZE_MB,
};
